const configStore = (() => {
  const configs = {}

  return {
    createConfig: (id) => {
      const newConfig = {
        elements: {},
        chart: {},
        currentValues: {
          initial_investment: 25000,
          investment_length: 1,
          monthly_contributions: 0,
          alternate_rate: 0.0,
        },
        currentSavings: {
          scu: [],
          banks: [],
        },
      }
      configs[id] = newConfig
      return newConfig
    },
    getConfig: (id) => configs[id],
  }
})()

export const updateCurrentValues = (id, key, value) => {
  const config = configStore.getConfig(id)
  if (config) {
    config.currentValues[key] = value
  }
}
export const createConfig = configStore.createConfig
export const getConfig = configStore.getConfig
